import { Component, Input, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FxDapHttpClient } from 'app/implementation/shared/fx-http-client';
@Component({
  selector: 'app-person-info',
  template: `
<div dw-popover id="personcontent" class="person-content" (click)="personcloseOpenWin($event)">
	<div id="salesperson"  class="person-sales">
	<div class="person-img">
		<div class="backperson-imgcontent">
      	<img class="backperson-img" src="assets/img/home/业务员.png">
		</div>
	   </div>
	   <div style="width: 50%;font-size: 14px;">
		   <div class="person-name"><i class="anticon anticon-user" style="margin-right: 5px;"></i>{{personInfor.bap001_n1}}</div>
		   <div style="color: #111111;">
		   <div class="person-list"><li class="person-lable">组织：</li>{{personInfor.baplorg_n1}}</div>
		   <div class="person-list"><li class="person-lable">部门：</li>{{personInfor.bapldept_n1}}</div>
		   <div class="person-list"><li class="person-lable">岗位：</li>{{personInfor.bap002_n1}}</div>
		   <div class="person-list"><li class="person-lable">上级：</li>{{personInfor.sbap001_n1}}</div>
		   <div class="person-list"><li class="person-lable">状态：</li>{{personInfor.bapstus_n1}}</div>
		   <div class="person-list"><li class="person-lable">电话：</li>{{personInfor.baptel}}</div>
		   <div class="person-list"><li class="person-lable">手机：</li>{{personInfor.bapmtel}}</div>
		   <div class="person-list"><li class="person-lable">邮件：</li>{{personInfor.bapmail}}</div>
		</div>
	  </div>
	</div>
</div>
  `,
  styles: [`
.person-content{
  top: 0px;left: 0px;height: 100%;width: 100%;position: absolute;z-index: 1000;display: none;
}
.person-content .person-sales{
  position: absolute;display: flex ;
	width: 400px;
	height: 295px;
	background-color: #FFFFFF;
	border-radius: 6px;box-shadow: 0px 0px 12px 0px rgba(79, 90, 103, 0.2);
}
.person-content .person-img{
  width: 50%;display: flex;align-items:center;
	justify-content:center;
}
.person-content .person-imgcontent{
  background-color: #B5E0E8;width: 170px;
  height: 241px;
  border-radius: 4px;
}
.person-content .person-name{
  height: 38px;display: flex;align-items:center;border-bottom:1px solid #EEEFF1;color: #111111;
}
.person-content .person-list{
  display: flex;height: 30px;display: flex;align-items:center;
}
.person-content .person-lable{
  color: #8A95A3;
}
.person-content .backperson-img{
 width: 90%;
    left: 5%;
    position: absolute;
    height: 85%;
    bottom: 0px;
}
.person-content .backperson-imgcontent{
position: absolute;
left: 16px;
top: 27px;
width: 170px;
height: 241px;
border-radius: 4px;
opacity: 1;
background: #B5E0E8;
  }
  `],
  encapsulation: ViewEncapsulation.None
})
export class PersonInfoComponent implements OnInit {

  public personInfor={
    bap001_n1:"",
    baplorg_n1:"",
    bapldept_n1:"",
    bap002_n1:"",
    bapstus_n1:"",
    baptel:"",
    bapmtel:"",
    bapmail:"",
    sbapstus_n1:""
  }; 
  constructor(
    public http: FxDapHttpClient) {
  }

  ngOnInit(): void {
    //获取初始数据
  }
  visible: boolean;

  clickMe(): void {
    this.visible = false;
  }

  change(value: boolean): void {
    console.log(value);
  }

  public showpersonInfor(e,baplorg,bap001){
    let param={bap001:bap001,baplorg:baplorg};
   this.http.post<any>('A/IACommonService/queryBap', { param: param}).subscribe(response => {
       if(response.success){
        this.personInfor=response.data;
        var div2 = document.getElementById('personcontent');
        var div = document.getElementById('salesperson');
        div2.style.display = 'block';
        var windowHeight = window.innerHeight;
        var windowWidth = window.innerWidth;
        if(e.clientY-40+295>windowHeight){
          div.style.top = (e.clientY-315) + 'px';
        }else{
          div.style.top = (e.clientY-50) + 'px';
        }
        if(e.clientX+400>windowWidth){
          div.style.left = (e.clientX-650) + 'px';
        }else{
          div.style.left = (e.clientX-150) + 'px';
        }
       }
    });
  }

  public personcloseOpenWin($event){
    var div2 = document.getElementById('personcontent');
    var div = document.getElementById('salesperson');
    if (!div.contains($event.target)) {
      div2.style.display = 'none';
    }
  }
}